import React, { useEffect, useState } from "react";
import { AppLayout } from "layout";
import { MyLearningData } from "modules/MyLearning/components";
import { PurchasesService } from "services/PurchasesService";
import { Purchase } from "types";
import { useAuth } from "context/authContext";
import { ContentsService } from "services/ContentsService";
import { LearningLogService } from "services/LearningLogService";

type Props = {};

const MyLearningContainer = (props: Props) => {
  const { currentUser } = useAuth();
  const [purchasesData, setPurchasesData] = useState<Purchase[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPurchases = async () => {
      setLoading(true);
      try {
        if (!currentUser?.uid) {
          console.error("User ID is not available.");
          return;
        }
        const data = await PurchasesService.getPurchasesByUser(currentUser.uid);

        // Fetch Learning Logs
        const learningLogs = await LearningLogService.getAllLearningLogs(currentUser.uid);



        // ✅ Merge Learning Logs into `cartItemData` inside `purchases`
        const mergedData = data.map((purchase: any) => {
          const logsForItem = learningLogs.filter((log: any) => log.contentId === purchase.id);

          return {
            ...purchase,
            cartItemData: purchase.cartItemData.map((cartItem: any) => ({
              ...cartItem,
              learningLogs: logsForItem.length > 0 ? logsForItem : [],
            })),
          };
        });



        setPurchasesData(mergedData);

      } catch (err) {
        console.error("Error fetching purchases:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPurchases();
  }, [currentUser]);

  return (
    <AppLayout>
      <MyLearningData purchasesData={purchasesData} loading={loading} />
    </AppLayout>
  );
};

export default MyLearningContainer;
